/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { faCheck, faSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { NQTCheckBoxProps } from './NQTCheckBox.models';

import './NQTCheckBox.scss';

/**
 * Controlled CheckBox Component - Keeps reference 'checkBoxObj' updated with checked state
 * Use updateHandler if you need to further manipulate the object or group array it belongs to (type)
 * @param param0
 * @returns
 */
const NQTCheckBox = (
  {
    ariaControls,
    checkBoxObj,
    children,
    containerClass,
    containerStyle,
    hideLabel,
    id,
    isIndeterminate,
    isMixed,
    label,
    type,
    updateHandler,
    disabled
  }: NQTCheckBoxProps
): JSX.Element => {
  // return this ref for keyUpHandler since the evenListener is not attached to inputEl
  const inputEl = useRef<HTMLInputElement>(null);
  // set focus to visible checkbox onClick/onChange
  const checkboxEl = useRef<HTMLSpanElement>(null);

  const [inlineStyle, setInlineStyle] = useState({});
  const [isSelected, setIsSelected] = useState(checkBoxObj.isSelected);


  useEffect(() => {
    if (containerStyle && containerStyle !== null) {
      setInlineStyle(containerStyle);
    }
  }, [containerStyle]);

  useEffect(() => {
    setIsSelected(checkBoxObj.isSelected);
    // if (disabled){
    //   console.log('CHECK use effect',disabled);
    //   //setIsDisabled(disabled);
    // } else {
    //   console.log('CHECK else use effect',disabled);
    //   //setIsDisabled(false)
    // }
   
  }, [checkBoxObj.isSelected]);

  useEffect(() => {
    if (isIndeterminate) {
      setIsSelected(false);
      checkBoxObj.isSelected = false;
      inputEl.current!.checked = false;
      inputEl.current!.indeterminate = true;
    } else {
      inputEl.current!.indeterminate = false;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIndeterminate]);

  const onChangeHandler = useCallback((e: React.FormEvent<HTMLInputElement>) => {

    e.stopPropagation();
    checkboxEl.current && checkboxEl.current.focus(); // maybe update handler redirects focus
    if (isIndeterminate) {
      updateHandler && (type ? updateHandler(type) : updateHandler());
    } else {
      setIsSelected(e.currentTarget.checked);
      checkBoxObj.isSelected = e.currentTarget.checked;
      updateHandler && (type ? updateHandler(type) : updateHandler());
    }
    

  }, [checkBoxObj, isIndeterminate, type, updateHandler]);

  const onKeyUpHandler = useCallback((e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (inputEl && (e.key === ' ' || e.key === 'Enter')) {
      if (inputEl.current) {
        if (isIndeterminate) {
          updateHandler && (type ? updateHandler(type) : updateHandler());
        } else {
          // Note: has to be the inverse since the handler is on the Span Element
          setIsSelected(!inputEl.current.checked);
          checkBoxObj.isSelected = !inputEl.current.checked;
          updateHandler && (type ? updateHandler(type) : updateHandler());
        }
      }
    }
  }, [checkBoxObj, isIndeterminate, type, updateHandler]);

  return (
    <div className={'nqt-checkbox-container ' + containerClass + (isSelected ? ' selected' : '')}
      style={inlineStyle}>
      {
        children
      }
      <label aria-labelledby={`${id}-label`} className='nqt-checkbox-label'
        htmlFor={id}>

       
        <input className='nqt-checkbox-input disabled'
          key={id}
          ref={inputEl}
          checked={isSelected}
          disabled={disabled}
          onClick={onChangeHandler}
          onChange={onChangeHandler}
          type='checkbox' id={id} />
        <span className='nqt-checkbox'
          ref={checkboxEl}
          role="checkbox"
          aria-checked={isMixed ? 'mixed' : isSelected}
          aria-controls={ariaControls}
          onKeyUp={onKeyUpHandler}
          tabIndex={disabled == true ? -1 : 0}>
         
          {
            isSelected &&
            <FontAwesomeIcon icon={faCheck}></FontAwesomeIcon>
          }
          {
            isIndeterminate &&
            <FontAwesomeIcon icon={faSquare}></FontAwesomeIcon>
          }
        </span>
        <span id={`${id}-label`} className={`nqt-checkbox-text${ hideLabel ? ' visually-hidden' : ''}`}>
          {label}
        </span>
      </label>
    </div>
  );
};

export default NQTCheckBox;